import { render, staticRenderFns } from "./RepositoryForm.vue?vue&type=template&id=3ec05c65"
import script from "./RepositoryForm.vue?vue&type=script&lang=js"
export * from "./RepositoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports